<template>
  <div>
    <div class="col-md-12 form-wrapper">
      <h2>Create Service Event</h2>
      <form id="create-event-form" @submit.prevent="createEvent">
        <div class="row g-3">
          <div class="col-md-6">
            <div class="form-group">
              <label for="date">Date</label>
              <input
                type="date"
                id="date"
                v-model="date"
                name="date"
                class="form-control"
              />
            </div>
            <div class="form-group mt-3">
              <label for="time">Time</label>
              <input
                type="number"
                id="time"
                v-model="time"
                name="time"
                class="form-control"
                placeholder="2"
                step="0.25"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="card-header">Partners</div>
              <div class="card-body">
                <div
                  v-for="(partner, index) in partners"
                  :key="index"
                  class="mb-2"
                >
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      v-model="partners[index]"
                      class="form-control"
                      placeholder="Partner name"
                    />
                    <button
                      class="btn btn-danger btn-sm ml-1"
                      type="button"
                      id="removePartnerButton"
                      @click="removePartner(index)"
                    >
                      Remove
                    </button>
                  </div>
                </div>
                <button
                  class="btn btn-outline-secondary btn-sm mt-1"
                  type="button"
                  @click="addPartner"
                >
                  + Add partner
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-3">
          <div class="d-flex justify-content-end mt-4">
            <router-link class="btn btn-primary btn-lg mr-2" to="/home"
              >Cancel</router-link
            >
            <button class="btn btn-success btn-lg" type="submit">
              Create Event
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="alert alert-danger" role="alert" v-if="postError">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { server } from "../../utils/helper";
import router from "../../router";
export default {
  data() {
    return {
      date: "",
      time: 0.0,
      partners: [],
      postError: false,
      errorMessage: "",
    };
  },
  computed: {
    console: () => console,
  },
  methods: {
    addPartner() {
      const partner = "";
      this.partners.push(partner);
    },
    removePartner(index) {
      this.partners.splice(index, 1);
    },
    createEvent() {
      let eventData = {
        date: this.date,
        time: this.time,
        partners: this.partners,
        user: "",
      };
      console.log(eventData);
      this._submitToServer(eventData);
    },
    _submitToServer(data) {
      const bearerToken = localStorage.getItem("jwt");
      if (!bearerToken) {
        this.postError = true;
        this.errorMessage = "Please log in to see events.";
      }
      axios
        .post(`${server.baseUrl}/events`, data, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .then(() => {
          router.push({ name: "home" });
        })
        .catch((error) => {
          this.console.log(error.response.message);
          this.postError = true;
          this.errorMessage = "Invalid request.";
        });
    },
  },
};
</script>
